import { render, staticRenderFns } from "./BuildPooledJSAs.vue?vue&type=template&id=4714945b&scoped=true"
import script from "./BuildPooledJSAs.vue?vue&type=script&lang=js"
export * from "./BuildPooledJSAs.vue?vue&type=script&lang=js"
import style0 from "./BuildPooledJSAs.vue?vue&type=style&index=0&id=4714945b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4714945b",
  null
  
)

export default component.exports